import { useState } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'

import Button from '../../../common/Button'
import Modal from '../../../common/Modal'
import ModalInnerWrapper from '../../../common/ModalInnerWrapper'
import PannelBody from '../../../fragments/PannelBody'
import Backdrop from '../../../common/modal/Backdrop'
import { deleteCaseSurgery } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import { caseActions } from '../../../../store/case'
import { surgicalActions } from '../../../../store/surgical'
import { surgeryCanBeDeleted } from '../../../../lib/misc'
import { useUserTabEditPermissionDisabled } from '../../../../lib/usersPermissions'

import classes from './SurgicalDrawer.module.css'

export default function DeleteSurgery({ itemData }) {
    const dispatch = useDispatch()
    const userPermissionDisabled = useUserTabEditPermissionDisabled('case_surgeries')

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [loading, setLoading] = useState(false)
    const [modalOpened, setModalOpened] = useState(false)

    const canDelete = surgeryCanBeDeleted(itemData)

    const openModalHandler = (event) => {
        event.preventDefault()
        event.stopPropagation()
        if (!userPermissionDisabled) {
            setModalOpened(true)
        }
    }

    const closeModalHandler = (event) => {
        event?.preventDefault?.()
        event?.stopPropagation?.()
        setModalOpened(false)
    }

    const deleteHandler = async (event) => {
        event.preventDefault()
        event.stopPropagation()

        if (userPermissionDisabled || loading) {
            return
        }

        setLoading(true)
        try {
            const result = await deleteCaseSurgery(userToken, activeCase.case.id, itemData.id, dispatch)

            if (result && result.errorMessage) {
                dispatch(notificationActions.setError(result))
            } else {
                dispatch(caseActions.removeFromArray({
                    folder: 'surgeries',
                    itemId: itemData.id,
                }))
                dispatch(surgicalActions.setActiveDrawer(null))
                dispatch(notificationActions.setError({ errorMessage: 'success', type: 'success' }))
                setModalOpened(false)
            }
        } finally {
            setLoading(false)
        }
    }

    if (!canDelete) {
        return null
    }

    return (
        <>
            <Button
                btnStyle="btn_danger"
                click={openModalHandler}
                type="button"
                title="Delete surgery"
                isDisabled={userPermissionDisabled}
                square={true}
            >
                <i className="ti ti-trash white" />
                <span className="sr-only">Delete surgery</span>
            </Button>
            {modalOpened && (
                <>
                    {ReactDOM.createPortal(
                        <Backdrop hide={closeModalHandler} />,
                        document.getElementById('backdrop-root')
                    )}
                    {ReactDOM.createPortal(
                        <Modal>
                            <ModalInnerWrapper closeModal={closeModalHandler} modalTitle="Delete surgery?">
                                <PannelBody>
                                    <form onSubmit={deleteHandler}>
                                        <p className="font-14">
                                            This surgery is not linked to a service.
                                        </p>
                                        <p className="font-14 m-top-12">
                                            Are you sure you want to delete it permanently? This action cannot be undone.
                                        </p>
                                        <div className={`flex-container-equal m-top-24 ${classes.delete_surgery_actions}`}>
                                            <Button
                                                btnStyle="btn_danger"
                                                type="submit"
                                                isLoading={loading}
                                            >
                                                <i className="ti ti-trash" /> Yes, delete
                                            </Button>
                                            <Button click={closeModalHandler} type="button">
                                                Cancel
                                            </Button>
                                        </div>
                                    </form>
                                </PannelBody>
                            </ModalInnerWrapper>
                        </Modal>,
                        document.getElementById('overlay-root')
                    )}
                </>
            )}
        </>
    )
}
